<template>
    <div class="vue-rental-option-modal-wrapper">
        <div class="modal-header d-flex justify-content-between align-items-start px-4 pt-4">
            <h3 class="modal-title mb-4">E-mailadres aanpassen</h3>

            <button class="close-button mt-1" @click="$modal.close()">
                {{ translations.closeText }}
            </button>
        </div>

        <div class="modal-body px-4 pb-4">
            <div v-if="successMessage" class="alert alert-success">
                {{ successMessage }}
            </div>
            <div v-if="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
            </div>

            <form @submit.prevent="handleSubmit" v-if="!successMessage">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="email">E-mailadres</label>
                            <input type="email" id="email" v-model="form.Email" class="form-control" required>
                        </div>
                    </div>
                </div>

                <div class="modal-actions">
                    <button type="button" class="btn btn-outline" @click="$modal.close()">Annuleren</button>
                    <button type="submit" class="btn btn-primary" :disabled="loading">
                        {{ loading ? 'Bezig met opslaan...' : 'Opslaan' }}
                    </button>
                </div>
            </form>

            <div v-else class="modal-actions">
                <button type="button" class="btn btn-primary" @click="$modal.close()">Sluiten</button>
            </div>
        </div>
    </div>
</template>

<script>
import translations from "../../mixins/translations";

export default {
    name: 'EditEmailModal',

    mixins: [translations],

    props: {
        userData: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            form: {
                ...this.userData,
                Email: this.userData.Email || '',
            },
            loading: false,
            successMessage: '',
            errorMessage: '',
        };
    },

    methods: {
        handleSubmit() {
            this.loading = true;
            this.errorMessage = '';
            this.successMessage = '';

            window.axios.post('/api/customer/update-data', this.form)
            .then(response => {
                this.successMessage = 'Uw e-mailadres is succesvol aangepast.';
                this.loading = false;
                this.$emit('data-updated');

                // Herlaad de pagina na een korte vertraging voor de zekerheid
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            })
            .catch(error => {
                this.errorMessage = error.response?.data?.error || 'Er is een fout opgetreden bij het opslaan.';
                this.loading = false;
            });
        }
    }
};
</script>

<style scoped>
.modal-title {
    margin: 0;
    font-size: 20px;
    color: #033239;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 0;
    padding-top: 1rem;
    font-weight: 600;
    color: #033239;
}

.form-control {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;
}

.btn {
    padding: 12px 24px;
    border-radius: 4px;
    font-weight: 700;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.5rem;
    font-size: 1rem;
    margin-top: 0;
}

.btn-primary {
    background: #82db39;
    border: 1px solid #82db39;
    color: #033239;
}

.btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-outline {
    background: transparent;
    border: 1px solid #ccc;
    color: #666;
}

.alert {
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.alert-success {
    background: #d4edda;
    color: #155724;
}

.alert-danger {
    background: #f8d7da;
    color: #721c24;
}
</style>
